export default "__VITE_ASSET__DTv48$F$__"